<template>
  <div class="el-upload">
    <el-form>
      <el-upload 
        :limit="1" 
        action="" drag :accept="suffix ? suffix : '*.*'" 
        :http-request="uploadFile" 
        :auto-upload="true" 
        :file-list="fileList" 
        :on-remove="removeFile">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    suffix: String,
    limit: Number,
    fileList: Array,
    onSuccess: Function
  },
  data() {
    return {
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  methods: {
    removeFile(){
      console.log('removeFile>>')
      this.$emit('getUrl', '')
    },
    uploadFile(e) {
      const file = e.file
      const size = file.size / 1024 / 1024 / 2
       if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '文件大小必须小于2M'
        })
      } else {
        const params = new FormData()
        params.append('file', file)
        if (this.suffix) {
          params.append('suffix', this.suffix)
        }
        this.$api.uploadFilesSuffix(params).then(res => {
          if (res.code === 0) {
            this.$message.success('上传成功')
            let url = this.ImgHttps + res.data
            console.log('imageUrl:', url)
            this.$emit('getUrl', url)
          } else {
            this.$message.error('上传失败')
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.el-upload {
  line-height: 1;
}
</style>